__turbopack_context__.v({
  "description": "StatsSectionStatic-module-scss-module__rU8wnW__description",
  "desktopStats": "StatsSectionStatic-module-scss-module__rU8wnW__desktopStats",
  "divider": "StatsSectionStatic-module-scss-module__rU8wnW__divider",
  "imageWrapper": "StatsSectionStatic-module-scss-module__rU8wnW__imageWrapper",
  "label": "StatsSectionStatic-module-scss-module__rU8wnW__label",
  "mobileSlide": "StatsSectionStatic-module-scss-module__rU8wnW__mobileSlide",
  "mobileSlideContainer": "StatsSectionStatic-module-scss-module__rU8wnW__mobileSlideContainer",
  "mobileStatBox": "StatsSectionStatic-module-scss-module__rU8wnW__mobileStatBox",
  "mobileStats": "StatsSectionStatic-module-scss-module__rU8wnW__mobileStats",
  "number": "StatsSectionStatic-module-scss-module__rU8wnW__number",
  "rightCard": "StatsSectionStatic-module-scss-module__rU8wnW__rightCard",
  "statBox": "StatsSectionStatic-module-scss-module__rU8wnW__statBox",
  "statImageBase": "StatsSectionStatic-module-scss-module__rU8wnW__statImageBase",
  "statImageHover": "StatsSectionStatic-module-scss-module__rU8wnW__statImageHover",
  "statsContainer": "StatsSectionStatic-module-scss-module__rU8wnW__statsContainer",
  "statsWrapper": "StatsSectionStatic-module-scss-module__rU8wnW__statsWrapper",
});
